<script setup>
import AdvancedTarazAzmayeshiManager from '@/views/plugins/tarazAzmayeshi/list/AdvancedTarazAzmayeshiManager.vue';

definePage({
  meta: {
    action: 'read',
    subject: 'tarazAzmayeshis',
  },
})
</script>

<template>
  <section>
    <AdvancedTarazAzmayeshiManager></AdvancedTarazAzmayeshiManager>
  </section>
</template>
